/**
 * Public brand host / support email derived from the current site hostname.
 * montestory.in → brand montestory.in, support@montestory.in
 * montestory.org → brand montestory.org, support@montestory.org
 */

export const DEFAULT_BRAND_DOMAIN = "montestory.in";

export function normalizeHost(value = "") {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .replace(/\/.*$/, "")
    .replace(/:\d+$/, "");
}

/**
 * Canonical public brand domain for display (no www / protocol).
 * Unknown / localhost hosts default to montestory.in.
 */
export function getBrandDomain(domainOrHost = "") {
  const host = normalizeHost(domainOrHost);
  if (!host) {
    if (typeof window !== "undefined") {
      return getBrandDomain(window.location.hostname || "");
    }
    return DEFAULT_BRAND_DOMAIN;
  }
  if (host === "montestory.org" || host.endsWith(".montestory.org")) {
    return "montestory.org";
  }
  if (host === "montestory.in" || host.endsWith(".montestory.in")) {
    return "montestory.in";
  }
  return DEFAULT_BRAND_DOMAIN;
}

export function getSupportEmail(domainOrHost = "") {
  return `support@${getBrandDomain(domainOrHost)}`;
}

/** e.g. www.montestory.org */
export function getWwwDomain(domainOrHost = "") {
  return `www.${getBrandDomain(domainOrHost)}`;
}

/** Absolute site URL for marketing/docs links */
export function getSiteUrl(domainOrHost = "") {
  if (typeof window !== "undefined" && window.location?.origin) {
    const current = getBrandDomain(window.location.hostname || "");
    const wanted = getBrandDomain(domainOrHost || window.location.hostname || "");
    if (current === wanted) {
      return window.location.origin;
    }
  }
  return `https://${getWwwDomain(domainOrHost)}`;
}

export function getBrandInfo(domainOrHost = "") {
  const brandDomain = getBrandDomain(domainOrHost);
  return {
    brandDomain,
    wwwDomain: `www.${brandDomain}`,
    supportEmail: `support@${brandDomain}`,
    siteUrl: getSiteUrl(domainOrHost || brandDomain),
  };
}
